// マウスホイールを横スクロールに変換
// トラックパッド横スワイプ（deltaX が deltaY より大きい）はネイティブに任せる
const funcWheelScroll = () => {
	const look = document.querySelector('.look');
	if (!look) return;

	look.addEventListener(
		'wheel',
		(e) => {
			if (Math.abs(e.deltaX) >= Math.abs(e.deltaY)) return;
			e.preventDefault();
			look.scrollLeft += e.deltaY * 1.5;
		},
		{ passive: false }
	);
};

// 横スクロール時のパラックス
const funcParallax = () => {
	const look = document.querySelector('.look');
	const imgs = document.querySelectorAll('.look__photo img');
	if (!look || !imgs.length) return;

	look.addEventListener(
		'scroll',
		() => {
			const sl = look.scrollLeft;
			imgs.forEach((img, i) => {
				const dir = i % 2 === 0 ? 1 : -1;
				const y = Math.max(-20, Math.min(20, sl * 0.035 * dir));
				img.style.transform = `translateY(${y}px)`;
			});
		},
		{ passive: true }
	);
};

// 横スクロールコンテナ内のフェードイン（CSS fadeInBlur 制御）
const funcLookAnim = () => {
	const look = document.querySelector('.look');
	const frames = document.querySelectorAll('.look .anim');
	if (!look || !frames.length) return;

	const check = () => {
		const right = look.getBoundingClientRect().right;
		frames.forEach((frame) => {
			if (frame.classList.contains('active')) return;
			if (frame.getBoundingClientRect().left < right - 60) {
				frame.classList.add('active');
			}
		});
	};

	look.addEventListener('scroll', check, { passive: true });
	setTimeout(check, 300);
};

// .look外の通常スクロールfadeIn
const funcAnim = () => {
	const items = document.querySelectorAll('#topicsList .anim');
	const lookFrames = document.querySelectorAll('.look .anim');
	const lookFrameSet = new Set(lookFrames);
	const outerItems = [...items].filter((el) => !lookFrameSet.has(el));
	if (!outerItems.length) return;

	const check = () => {
		const th = window.innerHeight * 0.9;
		outerItems.forEach((el) => {
			if (el.classList.contains('active')) return;
			const r = el.getBoundingClientRect();
			if (r.top < th && r.bottom > 0) el.classList.add('active');
		});
	};

	check();
	if (document.readyState !== 'complete') {
		window.addEventListener('load', check, { once: true });
	}
	window.addEventListener('scroll', check, { passive: true });
	window.addEventListener('resize', check);
};

// スクロール位置に応じて背景色をじわっと変える（7色を補間）
const funcBgColor = () => {
	const look = document.querySelector('.look');
	if (!look) return;

	// 左から右へ: 白 / 薄ピーチ / 薄ミント / 薄ブルー / 薄ベージュ / 薄ピンク / 白
	const colors = [
		[255, 255, 255],
		[255, 242, 220],
		[245, 250, 232],
		[238, 245, 251],
		[243, 238, 229],
		[253, 237, 235],
		[255, 255, 255],
	];

	const update = () => {
		const max = look.scrollWidth - look.clientWidth;
		if (max <= 0) return;
		const pct = Math.min(Math.max(look.scrollLeft / max, 0), 1);
		const seg = pct * (colors.length - 1);
		const idx = Math.min(Math.floor(seg), colors.length - 2);
		const t = seg - idx;
		const c1 = colors[idx];
		const c2 = colors[idx + 1];
		const r = Math.round(c1[0] + (c2[0] - c1[0]) * t);
		const g = Math.round(c1[1] + (c2[1] - c1[1]) * t);
		const b = Math.round(c1[2] + (c2[2] - c1[2]) * t);
		look.style.backgroundColor = `rgb(${r},${g},${b})`;
	};

	look.addEventListener('scroll', update, { passive: true });
	window.addEventListener('resize', update);
	update();
};

// スティッキーヘッダー: ヘッダーが流れたら表示、最後のフッターに到達したら非表示
const funcStickyHeader = () => {
	const look = document.querySelector('.look');
	const sticky = document.querySelector('.look__sticky');
	const head = document.querySelector('.look__frame--head');
	const footer = document.querySelector('.look__frame--allitems');
	if (!look || !sticky || !head) return;

	const check = () => {
		const passedHead = look.scrollLeft > head.offsetWidth;
		const reachedFooter = footer
			? look.scrollLeft + look.clientWidth >= footer.offsetLeft
			: false;

		if (passedHead && !reachedFooter) {
			sticky.classList.add('is-visible');
		} else {
			sticky.classList.remove('is-visible');
		}
	};

	look.addEventListener('scroll', check, { passive: true });
	window.addEventListener('resize', check);
	check();
};

// ALL ITEMSフローティングボタン：ヘッダー通過後に表示・最終ALL ITEMS到達で非表示
const funcAllItemsFab = () => {
	const look = document.querySelector('.look');
	const fab = document.querySelector('.look__fab');
	const head = document.querySelector('.look__frame--head');
	const footer = document.querySelector('.look__frame--allitems');
	if (!look || !fab || !head) return;

	const check = () => {
		const passedHead = look.scrollLeft > head.offsetWidth;
		const reachedFooter = footer
			? look.scrollLeft + look.clientWidth >= footer.offsetLeft
			: false;

		if (passedHead && !reachedFooter) {
			fab.classList.add('is-visible');
		} else {
			fab.classList.remove('is-visible');
		}
	};

	look.addEventListener('scroll', check, { passive: true });
	window.addEventListener('resize', check);
	check();
};

// 下部プログレスバー
const funcProgress = () => {
	const look = document.querySelector('.look');
	const bar = document.querySelector('.scroll-progress__bar');
	if (!look || !bar) return;

	look.addEventListener('scroll', () => {
		const max = look.scrollWidth - look.clientWidth;
		const pct = max > 0 ? (look.scrollLeft / max) * 100 : 0;
		bar.style.width = pct + '%';
	}, { passive: true });
};

// TOTOPボタン: lookセクションを先頭にスクロール
const funcTotop = () => {
	const look = document.querySelector('.look');
	const btn = document.querySelector('.look__totop');
	if (!look || !btn) return;

	btn.addEventListener('click', () => {
		look.scrollTo({ left: 0, behavior: 'smooth' });
	});
};

// SP: 縦スワイプを横スクロールに変換 + pull-to-refresh 防止 + 慣性スクロール
const funcTouchScroll = () => {
	const look = document.querySelector('.look');
	if (!look) return;

	let startX = 0, startY = 0, velocity = 0, rafId = null;

	look.addEventListener('touchstart', (e) => {
		startX = e.touches[0].clientX;
		startY = e.touches[0].clientY;
		velocity = 0;
		if (rafId) cancelAnimationFrame(rafId);
	}, { passive: true });

	look.addEventListener('touchmove', (e) => {
		const dx = e.touches[0].clientX - startX;
		const dy = e.touches[0].clientY - startY;
		if (Math.abs(dy) > Math.abs(dx)) {
			e.preventDefault();
			velocity = dy * 1.2;
			look.scrollLeft -= velocity;
			startX = e.touches[0].clientX;
			startY = e.touches[0].clientY;
		}
	}, { passive: false });

	look.addEventListener('touchend', () => {
		const decelerate = () => {
			if (Math.abs(velocity) < 0.5) return;
			velocity *= 0.92;
			look.scrollLeft -= velocity;
			rafId = requestAnimationFrame(decelerate);
		};
		rafId = requestAnimationFrame(decelerate);
	}, { passive: true });
};

window.addEventListener('DOMContentLoaded', () => {
	funcWheelScroll();
	funcTouchScroll();
	funcParallax();
	funcLookAnim();
	funcAnim();
	funcProgress();
	funcStickyHeader();
	funcAllItemsFab();
	funcTotop();
});
